import React, { useEffect, useState } from 'react';
import {
  Badge,
} from '@material-ui/core';

const MessagesBadge = (props) => {
    return <Badge badgeContent={Math.max(props.newMessages*1,0)} color="error">Сообщения</Badge>
}
  
export default MessagesBadge;